export const globalMessageChineseTraditional = {
  deactivate: "停用",
  success: "成功",
  search_placeholder: "搜尋...",
  select_placeholder: "請選擇...",
  array_placeholder: "多個值，用逗號分隔",
  select_variable: "選擇變數",
  press_enter_search: "按下 Enter 鍵搜尋",
  delete_success: "刪除成功",
  delete_failed: "刪除失敗",
  duplicate_success: "複製成功",
  duplicate_failed: "複製失敗",
  create_success: "建立成功",
  create_failed: "建立失敗",
  update_success: "更新成功",
  update_failed: "更新失敗",
  upload_success: "上傳成功",
  upload_failed: "上傳失敗",
  authenticate_success: "驗證成功",
  authenticate_failed: "驗證失敗",
  revealed_success: "顯示成功",
  revealed_failed: "顯示失敗",
  activate_success: "啟用成功",
  activate_failed: "啟用失敗",
  deactivate_success: "停用成功",
  deactivate_failed: "停用失敗",
  import_failed: "匯入失敗",
  import_success: "匯入成功",
  export_failed: "匯出失敗",
  export_success: "匯出成功",
  download_failed: "下載失敗",
  download_success: "下載成功",
  invite_success: "邀請成功",
  invite_failed: "邀請失敗",
  redeem_success: "兌換成功",

  export_credits_title: "匯出 {type} 為 CSV",
  export_credits_desc:
    "您即將匯出 {type}。根據您選擇的數量，這可能需要一點時間。",
  unsave: "取消儲存",
  draw_failed: "繪製失敗",
  please_fill: "請先填寫表單",
  field_not_valid: "欄位無效",
  enable: "啟用",
  disabled: "已停用",
  under_the_min_length: "少於最小數量",
  over_the_max_length: "超過最大數量",
  under_the_min_value: "低於最小值",
  over_the_max_value: "超過最大值",

  /** sort filter start */
  sort_filter_panel_title: "排序與篩選",
  sort_filter_panel_reset: "重設",
  sort_filter_panel_sort_by_title: "排序依據",
  sort_filter_panel_filter_title: "篩選",
  sort_filter_sort_by_create_descending: "建立日期（新到舊）",
  sort_filter_sort_by_create_ascending: "建立日期（舊到新）",
  sort_filter_sort_by_modify_descending: "最後修改（新到舊）",
  sort_filter_sort_by_modify_ascending: "最後修改（舊到新）",
  /** sort filter end */

  days: "天",
  hours: "小時",
  minutes: "分鐘",
  apply: "套用",

  sequence_editor_toolbar_link_form_text: "文字",
  sequence_editor_toolbar_link_form_url: "網址",

  authenticate_failure_title: "連線失敗",
  authenticate_failure_desc: "我們無法連接您的憑證。請檢查資料後再試一次。",
  authenticate_failure_button_text: "關閉",
  authenticate_success_title: "連線成功",
  authenticate_success_desc: "您的帳戶已連結，您現在可以開始使用它。",
  authenticate_success_button_text: "關閉",

  selections_desc_max:
    "您目前的方案最多可選擇 0 項。| 您目前的方案最多可選擇 1 項。| 您目前的方案最多可選擇 {count} 項。",
  selections_upgrade_now: "立即升級",
  selections_upgrade_now_desc: "以存取更多功能！",

  not_email_format: "不符合電郵格式",
  run_success: "執行成功",
  run_failed: "執行失敗",
  signUpFailed: "註冊失敗",
  signUpSuccess: "註冊成功",

  save_success: "儲存成功",
  save_failed: "儲存失敗",
  send_email_success: "電子郵件已成功發送至您的信箱。",
  send_email_failed: "發送電子郵件失敗",

  empty_list: "這裡還沒有內容",

  retry: "重試",

  remove_styles: "移除樣式",
  is_required: "{0}為必填項",

  current_page: "當前頁面",
  customize: "自訂",
  field_required: "此欄位為必填項",

  select_year: "選擇年份",
  select_month: "選擇月份",
  select_datetime: "選擇日期時間",

  asending: "升序",
  descending: "降序",
  copy: "複製",

  non_permission_field: "您沒有權限編輯此欄位",
  access_denied_title40348: "訪問請求被拒絕",
  access_denied_desc40348:
    "您的訪問請求已被工作區管理員拒絕。您可以聯繫管理員了解更多詳情或稍後再試。",
  access_denied_request40348: "請求訪問",
  access_denied_title40349: "訂閱權限被拒絕",
  access_denied_desc40349:
    "您當前的訂閱計劃不包括此功能的訪問權限。請升級您的訂閱以繼續使用。",
  access_denied_request40349: "升級訂閱",

  no_admin_found: "抱歉，未找到管理員帳戶。",

  started_at: "開始於 {0}",
  will_ends: "將於 {0} 結束",
  ended_at: "已於 {0} 結束",

  upcoming: "即將開始",
  ended: "已結束",

  input_number_format: "請輸入數值。",
  input_array_format: "請輸入陣列值。",
  input_string_format: "請輸入字串值。",

  field_type_not_match:
    '導入的數值："{value}" \n此數值無法匹配至 {name} 欄位。',
  already_exists: "此項已存在。請輸入不同的名稱。",
  invalid_url: "無效的 URL 格式",
  select_date: "請選擇日期",
  second_unit: "0 秒 | 1 秒 | {count} 秒",
  try_success: "測試成功",
  try_failed: "測試失敗",

  // sort
  sort_popover_timestamp_ascending: "最早優先",
  sort_popover_timestamp_descending: "最新優先",
  sort_popover_amount_ascending: "最低優先",
  sort_popover_amount_descending: "最高優先",
  sort_popover_cost_duration_ascending: "處理最快",
  sort_popover_cost_duration_descending: "處理最慢",
  sort_popover_alphabet_ascending: "A → Z",
  sort_popover_alphabet_descending: "Z → A",
  sort_popover_count_ascending: "數量最少",
  sort_popover_count_descending: "數量最多",

  last_modified: "最後修改時間",
  last_trigger_at: "最近觸發時間",
  create_at: "建立時間",
  total_credit: "總點數",
  processing_time_ms: "處理時間（毫秒）",
  total_signals: "訊號總數",
  retry_attempt: "重試次數",
  retry_success: "重試成功",
  retry_failed: "重試失敗",
  no_logs_to_retry: "沒有可重試的日誌",
  retry_partial_success: "已成功重試 {0}/{1} 筆日誌。請查看日誌了解詳情。",
  emailAlreadyExists: "此電郵地址已被使用。",
  validateEmailFailed: "電郵地址驗證失敗。",
  array_input_placeholder: "輸入關鍵字並按 Enter 鍵新增...",

  more_count: "+ {count} 個",
  company_url_name: "公司",
  linkedin_url_name: "LinkedIn",
  facebook_url_name: "Facebook",
  instagram_url_name: "Instagram",
  twitter_url_name: "Twitter",
  youtube_url_name: "YouTube",
  github_url_name: "GitHub",
  tiktok_url_name: "TikTok",
  x_url_name: "X",
  crunchbase_url_name: "Crunchbase",
  wantedly_url_name: "Wantedly",
  rocketpunch_url_name: "Rocketpunch",
  angelist_url_name: "AngelList",
  pinterest_url_name: "Pinterest",
  remember_url_name: "Remember",
  tw104_url_name: "104.com.tw",
  vimeo_url_name: "Vimeo",
  vk_url_name: "VK",
  youtrust_url_name: "YouTrust",

  or: "或",
  and: "且",
  match_prefix: "符合：",
};

export default globalMessageChineseTraditional;

export const globalMessageJapanese = {
  deactivate: "無効化",
  success: "成功",
  search_placeholder: "検索...",
  select_placeholder: "選択してください...",
  array_placeholder: "複数の値をカンマ区切りで",
  select_variable: "変数を選択",
  press_enter_search: "Enterキーを押して検索",
  delete_success: "削除成功",
  delete_failed: "削除失敗",
  duplicate_success: "複製成功",
  duplicate_failed: "複製失敗",
  create_success: "作成成功",
  create_failed: "作成失敗",
  update_success: "更新成功",
  update_failed: "更新失敗",
  upload_success: "アップロード成功",
  upload_failed: "アップロード失敗",
  authenticate_success: "認証成功",
  authenticate_failed: "認証失敗",
  revealed_success: "表示成功",
  revealed_failed: "表示失敗",
  activate_success: "有効化成功",
  activate_failed: "有効化失敗",
  deactivate_success: "無効化成功",
  deactivate_failed: "無効化失敗",
  import_failed: "インポート失敗",
  import_success: "インポート成功",
  export_failed: "エクスポート失敗",
  export_success: "エクスポート成功",
  download_failed: "ダウンロード失敗",
  download_success: "ダウンロード成功",
  invite_success: "招待成功",
  invite_failed: "招待失敗",
  redeem_success: "引き換えに成功しました",
  export_credits_title: "{type}をCSVでエクスポート",
  export_credits_desc:
    "{type}をエクスポートします。選択した量によっては時間がかかる場合があります。",
  unsave: "保存をキャンセル",
  draw_failed: "描画失敗",
  please_fill: "フォームを記入してください",
  field_not_valid: "無効なフィールド",
  enable: "有効化",
  disabled: "無効化済み",
  under_the_min_length: "最小数未満",
  over_the_max_length: "最大数超過",
  under_the_min_value: "最小値未満",
  over_the_max_value: "最大値超過",

  /** sort filter start */
  sort_filter_panel_title: "並べ替えとフィルタ",
  sort_filter_panel_reset: "リセット",
  sort_filter_panel_sort_by_title: "並べ替え基準",
  sort_filter_panel_filter_title: "フィルタ",
  sort_filter_sort_by_create_descending: "作成日（新しい順）",
  sort_filter_sort_by_create_ascending: "作成日（古い順）",
  sort_filter_sort_by_modify_descending: "最終更新（新しい順）",
  sort_filter_sort_by_modify_ascending: "最終更新（古い順）",
  /** sort filter end */

  days: "日",
  hours: "時間",
  minutes: "分",
  apply: "適用",

  sequence_editor_toolbar_link_form_text: "テキスト",
  sequence_editor_toolbar_link_form_url: "URL",

  authenticate_failure_title: "接続失敗",
  authenticate_failure_desc:
    "認証情報に接続できませんでした。データを確認して再試行してください。",
  authenticate_failure_button_text: "閉じる",
  authenticate_success_title: "接続成功",
  authenticate_success_desc:
    "アカウントが接続されました。これで使用を開始できます。",
  authenticate_success_button_text: "閉じる",

  selections_desc_max:
    "現在のプランでは最大0項目を選択できます。| 現在のプランでは最大1項目を選択できます。| 現在のプランでは最大{count}項目を選択できます。",
  selections_upgrade_now: "今すぐアップグレード",
  selections_upgrade_now_desc: "より多くの機能にアクセスしましょう！",

  not_email_format: "メール形式ではありません",
  run_success: "実行成功",
  run_failed: "実行失敗",
  signUpFailed: "登録失敗",
  signUpSuccess: "登録成功",

  save_success: "保存成功",
  save_failed: "保存失敗",
  send_email_success: "メールが送信されました。",
  send_email_failed: "メール送信失敗",

  empty_list: "ここにはまだ何もありません",

  retry: "再試行",

  remove_styles: "スタイルを削除",
  is_required: "{0}は必須項目です",

  current_page: "現在のページ",
  customize: "カスタマイズ",
  field_required: "このフィールドは必須です",
  select_year: "年を選択",
  select_month: "月を選択",
  select_datetime: "日時を選択",

  asending: "昇順",
  descending: "降順",
  copy: "コピー",

  non_permission_field: "このフィールドを編集する権限がありません",
  access_denied_title40348: "アクセスリクエストが拒否されました",
  access_denied_desc40348:
    "このセクションへのアクセスリクエストは、ワークスペース管理者によって拒否されました。詳細については管理者にお問い合わせいただくか、後でもう一度お試しください。",
  access_denied_request40348: "アクセスをリクエスト",
  access_denied_title40349: "サブスクリプション権限が拒否されました",
  access_denied_desc40349:
    "現在のプランにはこの機能へのアクセスが含まれていません。続行するにはサブスクリプションをアップグレードしてください。",
  access_denied_request40349: "サブスクリプションをアップグレード",

  no_admin_found:
    "申し訳ありませんが、管理者アカウントが見つかりませんでした。",

  started_at: "{0} に開始",
  will_ends: "{0} に終了予定",
  ended_at: "{0} に終了",

  upcoming: "近日開始",
  ended: "終了",

  input_number_format: "数値を入力してください。",
  input_array_format: "配列の値を入力してください。",
  input_string_format: "文字列を入力してください。",
  field_type_not_match:
    'インポートされた値："{value}" \nこの値は {name} フィールドに一致しません。',
  already_exists: "すでに存在します。異なる値を入力してください。",
  invalid_url: "無効な URL フォーマット",
  select_date: "日付を選択してください",
  second_unit: "0秒 | 1秒 | {count}秒",
  try_success: "テスト成功",
  try_failed: "テスト失敗",

  // sort
  sort_popover_timestamp_ascending: "古い順",
  sort_popover_timestamp_descending: "新しい順",
  sort_popover_amount_ascending: "低い順",
  sort_popover_amount_descending: "高い順",
  sort_popover_cost_duration_ascending: "処理時間が短い順",
  sort_popover_cost_duration_descending: "処理時間が長い順",
  sort_popover_alphabet_ascending: "A → Z",
  sort_popover_alphabet_descending: "Z → A",
  sort_popover_count_ascending: "件数が少ない順",
  sort_popover_count_descending: "件数が多い順",

  last_modified: "最終更新日時",
  last_trigger_at: "最終トリガー日時",
  create_at: "作成日時",
  total_credit: "合計クレジット",
  processing_time_ms: "処理時間（ms）",
  total_signals: "シグナル合計",
  retry_attempt: "再試行回数",
  retry_success: "再試行に成功しました",
  retry_failed: "再試行に失敗しました",
  no_logs_to_retry: "再試行可能なログはありません",
  retry_partial_success:
    "{1}件中{0}件のログを再試行しました。詳細はログを確認してください。",
  emailAlreadyExists: "このメールアドレスは既に使用されています。",
  validateEmailFailed: "メールアドレスの検証に失敗しました。",
  array_input_placeholder: "キーワードを入力して Enter キーで追加...",
  more_count: "+ {count} 件",
  company_url_name: "会社",
  linkedin_url_name: "LinkedIn",
  facebook_url_name: "Facebook",
  instagram_url_name: "Instagram",
  twitter_url_name: "Twitter",
  youtube_url_name: "YouTube",
  github_url_name: "GitHub",
  tiktok_url_name: "TikTok",
  x_url_name: "X",
  crunchbase_url_name: "Crunchbase",
  wantedly_url_name: "Wantedly",
  rocketpunch_url_name: "Rocketpunch",
  angelist_url_name: "AngelList",
  pinterest_url_name: "Pinterest",
  remember_url_name: "Remember",
  tw104_url_name: "104.com.tw",
  vimeo_url_name: "Vimeo",
  vk_url_name: "VK",
  youtrust_url_name: "YouTrust",

  or: "または",
  and: "かつ",
  match_prefix: "マッチ：",
};

export const globalMessageKorean = {
  deactivate: "비활성화",
  success: "성공",
  search_placeholder: "검색...",
  select_placeholder: "선택하세요...",
  array_placeholder: "여러 값, 쉼표로 구분",
  select_variable: "변수 선택",
  press_enter_search: "Enter 키를 눌러 검색",
  delete_success: "삭제 성공",
  delete_failed: "삭제 실패",
  duplicate_success: "복제 성공",
  duplicate_failed: "복제 실패",
  create_success: "생성 성공",
  create_failed: "생성 실패",
  update_success: "업데이트 성공",
  update_failed: "업데이트 실패",
  upload_success: "업로드 성공",
  upload_failed: "업로드 실패",
  authenticate_success: "인증 성공",
  authenticate_failed: "인증 실패",
  revealed_success: "표시 성공",
  revealed_failed: "표시 실패",
  activate_success: "활성화 성공",
  activate_failed: "활성화 실패",
  deactivate_success: "비활성화 성공",
  deactivate_failed: "비활성화 실패",
  import_failed: "가져오기 실패",
  import_success: "가져오기 성공",
  export_failed: "내보내기 실패",
  export_success: "내보내기 성공",
  download_failed: "다운로드 실패",
  download_success: "다운로드 성공",
  invite_success: "초대 성공",
  invite_failed: "초대 실패",
  redeem_success: "교환 성공",

  export_credits_title: "{type}을(를) CSV로 내보내기",
  export_credits_desc:
    "{type}을(를) 내보냅니다. 선택한 양에 따라 시간이 걸릴 수 있습니다.",
  unsave: "저장 취소",
  draw_failed: "그리기 실패",
  please_fill: "양식을 작성해 주세요",
  field_not_valid: "유효하지 않은 필드",
  enable: "활성화",
  disabled: "비활성화됨",
  under_the_min_length: "최소 수량 미만",
  over_the_max_length: "최대 수량 초과",
  under_the_min_value: "최소값 미만",
  over_the_max_value: "최대값 초과",
  /** sort filter start */
  sort_filter_panel_title: "정렬 및 필터",
  sort_filter_panel_reset: "재설정",
  sort_filter_panel_sort_by_title: "정렬 기준",
  sort_filter_panel_filter_title: "필터",
  sort_filter_sort_by_create_descending: "생성일 (최신순)",
  sort_filter_sort_by_create_ascending: "생성일 (오래된순)",
  sort_filter_sort_by_modify_descending: "최종 수정 (최신순)",
  sort_filter_sort_by_modify_ascending: "최종 수정 (오래된순)",
  /** sort filter end */

  days: "일",
  hours: "시간",
  minutes: "분",
  apply: "적용",

  sequence_editor_toolbar_link_form_text: "텍스트",
  sequence_editor_toolbar_link_form_url: "URL",

  authenticate_failure_title: "연결 실패",
  authenticate_failure_desc:
    "자격 증명에 연결할 수 없습니다. 데이터를 확인하고 다시 시도하세요.",
  authenticate_failure_button_text: "닫기",
  authenticate_success_title: "연결 성공",
  authenticate_success_desc:
    "계정이 연결되었습니다. 이제 사용을 시작할 수 있습니다.",
  authenticate_success_button_text: "닫기",

  selections_desc_max:
    "현재 요금제에서는 최대 0개를 선택할 수 있습니다.| 현재 요금제에서는 최대 1개를 선택할 수 있습니다.| 현재 요금제에서는 최대 {count}개를 선택할 수 있습니다.",
  selections_upgrade_now: "지금 업그레이드",
  selections_upgrade_now_desc: "더 많은 기능을 이용하세요!",

  not_email_format: "이메일 형식이 아닙니다",
  run_success: "실행 성공",
  run_failed: "실행 실패",
  signUpFailed: "가입 실패",
  signUpSuccess: "가입 성공",

  save_success: "저장 성공",
  save_failed: "저장 실패",
  send_email_success: "이메일이 성공적으로 발송되었습니다.",
  send_email_failed: "이메일 발송 실패",

  empty_list: "아직 내용이 없습니다",

  retry: "다시 시도",

  remove_styles: "스타일 제거",
  is_required: "{0}은(는) 필수 항목입니다",

  current_page: "현재 페이지",
  customize: "사용자 지정",
  field_required: "이 필드는 필수입니다",
  select_year: "연도 선택",
  select_month: "월 선택",
  select_datetime: "날짜 및 시간을 선택",

  asending: "오름차순",
  descending: "내림차순",
  copy: "복사",

  non_permission_field: "이 필드를 편집할 권한이 없습니다",
  access_denied_title40348: "액세스 요청이 거부되었습니다",
  access_denied_desc40348:
    "이 섹션에 대한 액세스 요청이 워크스페이스 관리자로부터 거부되었습니다. 자세한 내용은 관리자에게 문의하거나 나중에 다시 시도하세요.",
  access_denied_request40348: "액세스 요청",
  access_denied_title40349: "구독 권한 거부",
  access_denied_desc40349:
    "현재 플랜에는 이 기능에 대한 액세스가 포함되어 있지 않습니다. 계속하려면 구독을 업그레이드하세요.",
  access_denied_request40349: "구독 업그레이드",

  no_admin_found: "죄송합니다. 관리자 계정을 찾을 수 없습니다.",

  started_at: "{0} 시작",
  will_ends: "{0} 종료 예정",
  ended_at: "{0} 종료됨",

  upcoming: "예정",
  ended: "종료",

  input_number_format: "숫자 값을 입력하세요.",
  input_array_format: "배열 값을 입력하세요.",
  input_string_format: "문자열 값을 입력하세요.",
  field_type_not_match:
    '가져온 값: "{value}" \n이 값은 {name} 필드와 일치하지 않습니다.',
  already_exists: "이미 존재합니다. 다른 값을 입력해주세요.",
  invalid_url: "잘못된 URL 형식",
  select_date: "날짜를 선택해주세요",
  second_unit: "0초 | 1초 | {count}초",
  try_success: "테스트 성공",
  try_failed: "테스트 실패",

  // sort
  sort_popover_timestamp_ascending: "오래된 순",
  sort_popover_timestamp_descending: "최신 순",
  sort_popover_amount_ascending: "낮은 값 우선",
  sort_popover_amount_descending: "높은 값 우선",
  sort_popover_cost_duration_ascending: "처리 시간 짧은 순",
  sort_popover_cost_duration_descending: "처리 시간 긴 순",
  sort_popover_alphabet_ascending: "A → Z",
  sort_popover_alphabet_descending: "Z → A",
  sort_popover_count_ascending: "건수 적은 순",
  sort_popover_count_descending: "건수 많은 순",

  last_modified: "최종 수정 일시",
  last_trigger_at: "마지막 트리거 시각",
  create_at: "생성 일시",
  total_credit: "총 크레딧",
  processing_time_ms: "처리 시간(ms)",
  total_signals: "총 시그널 수",
  retry_attempt: "재시도 횟수",
  retry_success: "재시도에 성공했습니다",
  retry_failed: "재시도에 실패했습니다",
  no_logs_to_retry: "재시도할 로그가 없습니다",
  retry_partial_success:
    "총 {1}개 중 {0}개의 로그를 재시도했습니다. 자세한 내용은 로그를 확인하세요.",
  emailAlreadyExists: "이미 사용 중인 이메일 주소입니다.",
  validateEmailFailed: "이메일 주소 검증에 실패했습니다.",
  array_input_placeholder: "키워드를 입력한 뒤 Enter 키를 눌러 추가...",

  more_count: "+ {count}개 더",
  company_url_name: "회사",
  linkedin_url_name: "LinkedIn",
  facebook_url_name: "Facebook",
  instagram_url_name: "Instagram",
  twitter_url_name: "Twitter",
  youtube_url_name: "YouTube",
  github_url_name: "GitHub",
  tiktok_url_name: "TikTok",
  x_url_name: "X",
  crunchbase_url_name: "Crunchbase",
  wantedly_url_name: "Wantedly",
  rocketpunch_url_name: "Rocketpunch",
  angelist_url_name: "AngelList",
  pinterest_url_name: "Pinterest",
  remember_url_name: "Remember",
  tw104_url_name: "104.com.tw",
  vimeo_url_name: "Vimeo",
  vk_url_name: "VK",
  youtrust_url_name: "YouTrust",

  or: "또는",
  and: "그리고",
  match_prefix: "일치:",
};

export const globalMessageHindi = {
  deactivate: "निष्क्रिय करें",
  success: "सफल",
  search_placeholder: "खोजें...",
  select_placeholder: "चुनें...",
  array_placeholder: "एकाधिक मान, अल्पविराम से अलग",
  select_variable: "चर चुनें",
  press_enter_search: "खोजने के लिए Enter दबाएं",
  delete_success: "हटाना सफल",
  delete_failed: "हटाना विफल",
  duplicate_success: "प्रतिलिपि सफल",
  duplicate_failed: "प्रतिलिपि विफल",
  create_success: "बनाना सफल",
  create_failed: "बनाना विफल",
  update_success: "अद्यतन सफल",
  update_failed: "अद्यतन विफल",
  upload_success: "अपलोड सफल",
  upload_failed: "अपलोड विफल",
  authenticate_success: "प्रमाणीकरण सफल",
  authenticate_failed: "प्रमाणीकरण विफल",
  revealed_success: "प्रदर्शन सफल",
  revealed_failed: "प्रदर्शन विफल",
  activate_success: "सक्रियण सफल",
  activate_failed: "सक्रियण विफल",
  deactivate_success: "निष्क्रियण सफल",
  deactivate_failed: "निष्क्रियण विफल",
  import_failed: "आयात विफल",
  import_success: "आयात सफल",
  export_failed: "निर्यात विफल",
  export_success: "निर्यात सफल",
  download_failed: "डाउनलोड विफल",
  download_success: "डाउनलोड सफल",
  invite_success: "आमंत्रण सफल",
  invite_failed: "आमंत्रण विफल",
  redeem_success: "सफलतापूर्वक रिडीम किया गया",

  export_credits_title: "{type} को CSV के रूप में निर्यात करें",
  export_credits_desc:
    "आप {type} को निर्यात करने जा रहे हैं। चयनित मात्रा के आधार पर, इसमें थोड़ा समय लग सकता है।",
  unsave: "सहेजना रद्द करें",
  draw_failed: "आरेखण विफल",
  please_fill: "कृपया फॉर्म भरें",
  field_not_valid: "अमान्य फ़ील्ड",
  enable: "सक्षम करें",
  disabled: "अक्षम",
  under_the_min_length: "न्यूनतम संख्या से कम",
  over_the_max_length: "अधिकतम संख्या से अधिक",
  under_the_min_value: "न्यूनतम मान से कम",
  over_the_max_value: "अधिकतम मान से अधिक",
  /** sort filter start */
  sort_filter_panel_title: "क्रमबद्ध करें और फ़िल्टर करें",
  sort_filter_panel_reset: "रीसेट",
  sort_filter_panel_sort_by_title: "क्रमबद्ध करने का आधार",
  sort_filter_panel_filter_title: "फ़िल्टर",
  sort_filter_sort_by_create_descending: "निर्माण तिथि (नया से पुराना)",
  sort_filter_sort_by_create_ascending: "निर्माण तिथि (पुराना से नया)",
  sort_filter_sort_by_modify_descending: "अंतिम संशोधन (नया से पुराना)",
  sort_filter_sort_by_modify_ascending: "अंतिम संशोधन (पुराना से नया)",
  /** sort filter end */

  days: "दिन",
  hours: "घंटे",
  minutes: "मिनट",
  apply: "लागू करें",

  sequence_editor_toolbar_link_form_text: "पाठ",
  sequence_editor_toolbar_link_form_url: "URL",

  authenticate_failure_title: "कनेक्शन विफल",
  authenticate_failure_desc:
    "हम आपकी साख से कनेक्ट नहीं कर पाए। कृपया डेटा जांचकर पुनः प्रयास करें।",
  authenticate_failure_button_text: "बंद करें",
  authenticate_success_title: "कनेक्शन सफल",
  authenticate_success_desc:
    "आपका खाता जुड़ गया है, अब आप इसका उपयोग शुरू कर सकते हैं।",
  authenticate_success_button_text: "बंद करें",

  selections_desc_max:
    "आपकी वर्तमान योजना में अधिकतम 0 आइटम चुन सकते हैं।| आपकी वर्तमान योजना में अधिकतम 1 आइटम चुन सकते हैं।| आपकी वर्तमान योजना में अधिकतम {count} आइटम चुन सकते हैं。",
  selections_upgrade_now: "अभी अपग्रेड करें",
  selections_upgrade_now_desc: "अधिक सुविधाओं तक पहुंच प्राप्त करें!",

  not_email_format: "ईमेल प्रारूप नहीं है",
  run_success: "निष्पादन सफल",
  run_failed: "निष्पादन विफल",
  signUpFailed: "पंजीकरण विफल",
  signUpSuccess: "पंजीकरण सफल",

  save_success: "सहेजना सफल",
  save_failed: "सहेजना विफल",
  send_email_success: "ईमेल आपके इनबॉक्स में सफलतापूर्वक भेज दिया गया है।",
  send_email_failed: "ईमेल भेजने में विफल",

  empty_list: "यहां अभी तक कुछ नहीं है",

  retry: "पुनः प्रयास करें",

  remove_styles: "शैलियाँ हटाएं",
  is_required: "{0} आवश्यक है",

  current_page: "वर्तमान पृष्ठ",
  customize: "अनुकूलित करें",
  field_required: "यह फ़ील्ड आवश्यक है",

  select_year: "वर्ष चुनें",
  select_month: "महीना चुनें",
  select_datetime: "दिनांक और समय चुनें",

  asending: "आरोही",
  descending: "अवरोही",
  copy: "कॉपी",

  non_permission_field: "आपको इस फ़ील्ड को संपादित करने की अनुमति नहीं है",
  access_denied_title40348: "पहुंच अनुरोध अस्वीकृत",
  access_denied_desc40348:
    "इस अनुभाग तक पहुंचने का आपका अनुरोध आपके कार्यक्षेत्र व्यवस्थापक द्वारा अस्वीकार कर दिया गया है। अधिक जानकारी के लिए अपने व्यवस्थापक से संपर्क करें या बाद में पुनः प्रयास करें।",
  access_denied_request40348: "पहुंच का अनुरोध करें",
  access_denied_title40349: "सदस्यता अनुमति अस्वीकृत",
  access_denied_desc40349:
    "आपकी वर्तमान योजना में इस सुविधा तक पहुंच शामिल नहीं है। जारी रखने के लिए अपनी सदस्यता अपग्रेड करें।",
  access_denied_request40349: "सदस्यता अपग्रेड करें",

  no_admin_found: "क्षमा करें, कोई व्यवस्थापक खाता नहीं मिला।",

  started_at: "{0} से शुरू",
  will_ends: "{0} को समाप्त होगा",
  ended_at: "{0} को समाप्त",

  upcoming: "आगामी",
  ended: "समाप्त",

  input_number_format: "कृपया एक संख्यात्मक मान दर्ज करें।",
  input_array_format: "कृपया एक ऐरे मान दर्ज करें।",
  input_string_format: "कृपया एक स्ट्रिंग मान दर्ज करें।",
  field_type_not_match:
    'आयातित मान: "{value}" \nयह मान {name} फ़ील्ड से मेल नहीं खा सका।',
  already_exists: "यह पहले से मौजूद है। कृपया एक अलग मान दर्ज करें।",
  invalid_url: "अवैध URL प्रारूप",
  select_date: "कृपया एक तारीख चुनें",
  second_unit: "0 सेकंड | 1 सेकंड | {count} सेकंड",
  try_success: "परीक्षण सफल",
  try_failed: "परीक्षण विफल",

  // sort
  sort_popover_timestamp_ascending: "सबसे पुराना पहले",
  sort_popover_timestamp_descending: "सबसे नया पहले",
  sort_popover_amount_ascending: "सबसे कम पहले",
  sort_popover_amount_descending: "सबसे अधिक पहले",
  sort_popover_cost_duration_ascending: "सबसे तेज़ पहले",
  sort_popover_cost_duration_descending: "सबसे धीमा पहले",
  sort_popover_alphabet_ascending: "A → Z",
  sort_popover_alphabet_descending: "Z → A",
  sort_popover_count_ascending: "सबसे कम संख्या पहले",
  sort_popover_count_descending: "सबसे अधिक संख्या पहले",

  last_modified: "अंतिम संशोधन",
  last_trigger_at: "अंतिम ट्रिगर समय",
  create_at: "निर्माण समय",
  total_credit: "कुल क्रेडिट",
  processing_time_ms: "प्रोसेसिंग समय (ms)",
  total_signals: "कुल सिग्नल",
  retry_attempt: "पुनः प्रयास संख्या",
  retry_success: "पुनः प्रयास सफल रहा",
  retry_failed: "पुनः प्रयास विफल रहा",
  no_logs_to_retry: "पुनः प्रयास के लिए कोई लॉग उपलब्ध नहीं है",
  retry_partial_success:
    "{1} में से {0} लॉग का पुनः प्रयास सफल रहा। अधिक जानकारी के लिए लॉग देखें।",
  emailAlreadyExists: "यह ईमेल पता पहले से उपयोग में है।",
  validateEmailFailed: "ईमेल पते का सत्यापन विफल रहा।",
  array_input_placeholder: "कीवर्ड दर्ज करें और जोड़ने के लिए Enter दबाएँ...",
  more_count: "+ {count} और",
  company_url_name: "कंपनी",
  linkedin_url_name: "LinkedIn",
  facebook_url_name: "Facebook",
  instagram_url_name: "Instagram",
  twitter_url_name: "Twitter",
  youtube_url_name: "YouTube",
  github_url_name: "GitHub",
  tiktok_url_name: "TikTok",
  x_url_name: "X",
  crunchbase_url_name: "Crunchbase",
  wantedly_url_name: "Wantedly",
  rocketpunch_url_name: "Rocketpunch",
  angelist_url_name: "AngelList",
  pinterest_url_name: "Pinterest",
  remember_url_name: "Remember",
  tw104_url_name: "104.com.tw",
  vimeo_url_name: "Vimeo",
  vk_url_name: "VK",
  youtrust_url_name: "YouTrust",

  or: "या",
  and: "और",
  match_prefix: "मिलान:",
};
